import { render, staticRenderFns } from "./DeviceImageSetting.vue?vue&type=template&id=83fb2bbc&scoped=true&"
import script from "./DeviceImageSetting.vue?vue&type=script&lang=js&"
export * from "./DeviceImageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fb2bbc",
  null
  
)

export default component.exports